import mutations from './mutations'
import actions from './actions'
import injector from 'vue-inject'

export default {
  namespaced: true,
  state: {
    // TODO: 這個之後要放到 localforage
    channels: {
      main: {
        getFilterConfig: injector.get('filterConfigs').getKitchenFilterConfig,
        orderList: []
      },
      secondary: {
        getFilterConfig: injector.get('filterConfigs').getPreOrderFilterConfig,
        orderList: []
      }
    },
    newOrder: null,
    orderErrorMessage: null
  },
  getters: {
    mainOrderList: state => state.channels.main.orderList,
    secondaryOrderList: state => state.channels.secondary.orderList
  },
  mutations,
  actions
}
